function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1936(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 33.7,
    height: 19.48,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.2466666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.85,
    y: 9.74
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 19.48,
    width: 33.7,
    height: 19.59,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.959
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.85,
    y: 29.275
  }, "\n        Perquimans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 39.07,
    width: 33.7,
    height: 23.43,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.347142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.85,
    y: 50.785
  }, "\n        Tyrrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 62.5,
    width: 33.7,
    height: 25.27,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.3175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.85,
    y: 75.135
  }, "\n        Hyde\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 87.77,
    width: 33.7,
    height: 27.92,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.5840000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.85,
    y: 101.72999999999999
  }, "\n        Gates\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 115.69,
    width: 33.7,
    height: 28.51,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.751666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.85,
    y: 129.945
  }, "\n        Chowan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 144.2,
    width: 33.7,
    height: 30.33,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.066
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.85,
    y: 159.36499999999998
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 174.52,
    width: 33.7,
    height: 30.36,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.373333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.85,
    y: 189.70000000000002
  }, "\n        Currituck\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 204.88,
    width: 33.7,
    height: 33.44,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.36
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.85,
    y: 221.6
  }, "\n        Dare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 238.33,
    width: 33.7,
    height: 36.27,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.85,
    y: 256.46500000000003
  }, "\n        Hoke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 274.59,
    width: 33.7,
    height: 41.74,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.37
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.85,
    y: 295.46
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 316.33,
    width: 33.7,
    height: 41.76,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.2125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.85,
    y: 337.21
  }, "\n        Hertford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 358.09,
    width: 33.7,
    height: 43.07,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.814285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.85,
    y: 379.625
  }, "\n        Pamlico\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 401.16,
    width: 33.7,
    height: 46.76,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.814285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.85,
    y: 424.54
  }, "\n        Caswell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 447.92,
    width: 33.7,
    height: 46.97,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.616666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.85,
    y: 471.40500000000003
  }, "\n        Pender\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 494.89,
    width: 33.7,
    height: 48.46,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.616666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.85,
    y: 519.12
  }, "\n        Graham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 543.35,
    width: 33.7,
    height: 49.62,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.85,
    y: 568.16
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 592.97,
    width: 33.7,
    height: 51.84,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.616666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.85,
    y: 618.89
  }, "\n        Onslow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 644.8,
    width: 33.7,
    height: 55.2,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.616666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.85,
    y: 672.4
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.7,
    y: 0,
    width: 38.9,
    height: 48.22,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.483333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.150000000000006,
    y: 24.11
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.6,
    y: 0,
    width: 39.73,
    height: 48.22,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.621666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 92.46499999999999,
    y: 24.11
  }, "\n        Person\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 112.33,
    y: 0,
    width: 42.34,
    height: 48.22,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.2925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 133.5,
    y: 24.11
  }, "\n        Scotland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 154.67,
    y: 0,
    width: 42.98,
    height: 48.22,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.298
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 176.16,
    y: 24.11
  }, "\n        Pasquotank\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 197.65,
    y: 0,
    width: 46.12,
    height: 48.22,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.224
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 220.71,
    y: 24.11
  }, "\n        Avery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 243.77,
    y: 0,
    width: 46.52,
    height: 48.22,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.1688888888888895
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 267.03000000000003,
    y: 24.11
  }, "\n        Alleghany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 290.29,
    y: 0,
    width: 47.14,
    height: 48.22,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.285454545454545
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 313.86,
    y: 24.11
  }, "\n        Northampton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 337.43,
    y: 0,
    width: 47.35,
    height: 48.22,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.891666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 361.105,
    y: 24.11
  }, "\n        Bladen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 384.78,
    y: 0,
    width: 47.73,
    height: 48.22,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.954999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 408.645,
    y: 24.11
  }, "\n        Bertie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 432.52,
    y: 0,
    width: 52.24,
    height: 48.22,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.055
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 458.64,
    y: 24.11
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 484.75,
    y: 0,
    width: 52.48,
    height: 48.22,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.357777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 510.99,
    y: 24.11
  }, "\n        Brunswick\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 537.23,
    y: 0,
    width: 53.18,
    height: 48.22,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.073333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 563.82,
    y: 24.11
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 590.42,
    y: 0,
    width: 54.04,
    height: 48.22,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.357777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 617.4399999999999,
    y: 24.11
  }, "\n        Granville\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 644.46,
    y: 0,
    width: 55.54,
    height: 48.22,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.036666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 672.23,
    y: 24.11
  }, "\n        Martin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.7,
    y: 48.22,
    width: 56.81,
    height: 48.32,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.664
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.105000000000004,
    y: 72.38
  }, "\n        Swain\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.7,
    y: 96.54,
    width: 56.81,
    height: 49.79,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.149166666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.105000000000004,
    y: 121.435
  }, "\n        Transylvania\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.7,
    y: 146.33,
    width: 56.81,
    height: 49.84,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.968
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.105000000000004,
    y: 171.25
  }, "\n        Vance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.7,
    y: 196.17,
    width: 56.81,
    height: 51.15,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.23
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.105000000000004,
    y: 221.74499999999998
  }, "\n        Davie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.7,
    y: 247.31,
    width: 56.81,
    height: 51.47,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.294
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.105000000000004,
    y: 273.045
  }, "\n        Anson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.7,
    y: 298.79,
    width: 56.81,
    height: 52.06,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.5075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.105000000000004,
    y: 324.82000000000005
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.7,
    y: 350.85,
    width: 56.81,
    height: 54.52,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.086666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.105000000000004,
    y: 378.11
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.7,
    y: 405.36,
    width: 56.81,
    height: 55.89,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.98625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.105000000000004,
    y: 433.305
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.7,
    y: 461.26,
    width: 56.81,
    height: 58.25,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.10125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.105000000000004,
    y: 490.385
  }, "\n        Carteret\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.7,
    y: 519.5,
    width: 56.81,
    height: 58.7,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.312222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.105000000000004,
    y: 548.85
  }, "\n        Alexander\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.7,
    y: 578.2,
    width: 56.81,
    height: 60.26,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.362
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.105000000000004,
    y: 608.33
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.7,
    y: 638.46,
    width: 56.81,
    height: 61.54,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.681
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.105000000000004,
    y: 669.23
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.52,
    y: 48.22,
    width: 54.27,
    height: 64.49,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.045
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 117.655,
    y: 80.465
  }, "\n        Craven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.79,
    y: 48.22,
    width: 56.16,
    height: 64.49,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.36
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 172.87,
    y: 80.465
  }, "\n        Lenoir\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 200.95,
    y: 48.22,
    width: 56.97,
    height: 64.49,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.495
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 229.435,
    y: 80.465
  }, "\n        Yancey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 257.92,
    y: 48.22,
    width: 59.33,
    height: 64.49,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.475714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 287.58500000000004,
    y: 80.465
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 317.25,
    y: 48.22,
    width: 60.53,
    height: 64.49,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.56625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 347.515,
    y: 80.465
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 377.78,
    y: 48.22,
    width: 62.88,
    height: 64.49,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.576
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 409.21999999999997,
    y: 80.465
  }, "\n        Moore\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 440.66,
    y: 48.22,
    width: 62.91,
    height: 64.49,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.989999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 472.115,
    y: 80.465
  }, "\n        Edgecombe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 503.57,
    y: 48.22,
    width: 64.24,
    height: 64.49,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.03
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 535.6899999999999,
    y: 80.465
  }, "\n        Beaufort\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 567.81,
    y: 48.22,
    width: 65.98,
    height: 64.49,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.212857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 600.8,
    y: 80.465
  }, "\n        Watauga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 633.78,
    y: 48.22,
    width: 66.22,
    height: 64.49,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.06125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 666.89,
    y: 80.465
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.52,
    y: 112.71,
    width: 69.27,
    height: 62.44,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.406666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 125.155,
    y: 143.93
  }, "\n        Yadkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.52,
    y: 175.14,
    width: 69.27,
    height: 63.3,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.549999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 125.155,
    y: 206.79
  }, "\n        Duplin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.52,
    y: 238.45,
    width: 69.27,
    height: 63.45,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.345000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 125.155,
    y: 270.175
  }, "\n        Cumberland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.52,
    y: 301.9,
    width: 69.27,
    height: 63.82,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.9775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 125.155,
    y: 333.81
  }, "\n        Columbus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.52,
    y: 365.71,
    width: 69.27,
    height: 64.39,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.198571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 125.155,
    y: 397.905
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.52,
    y: 430.11,
    width: 69.27,
    height: 64.41,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.735
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 125.155,
    y: 462.315
  }, "\n        Stokes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.52,
    y: 494.51,
    width: 69.27,
    height: 68.01,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 125.155,
    y: 528.515
  }, "\n        Wilson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.52,
    y: 562.53,
    width: 69.27,
    height: 68.1,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.62
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 125.155,
    y: 596.5799999999999
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.52,
    y: 630.63,
    width: 69.27,
    height: 69.37,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.895714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 125.155,
    y: 665.315
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 159.79,
    y: 112.71,
    width: 62.9,
    height: 78.57,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.8625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 191.23999999999998,
    y: 151.995
  }, "\n        McDowell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 222.68,
    y: 112.71,
    width: 63.43,
    height: 78.57,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.061428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 254.395,
    y: 151.995
  }, "\n        Halifax\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 286.12,
    y: 112.71,
    width: 64.5,
    height: 78.57,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.863636363636363
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 318.37,
    y: 151.995
  }, "\n        New_Hanover\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 350.62,
    y: 112.71,
    width: 65.66,
    height: 78.57,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.132
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 383.45,
    y: 151.995
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 416.28,
    y: 112.71,
    width: 66.98,
    height: 78.57,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.56857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 449.77,
    y: 151.995
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 483.27,
    y: 112.71,
    width: 68.34,
    height: 78.57,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.085
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 517.4399999999999,
    y: 151.995
  }, "\n        Nash\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 551.61,
    y: 112.71,
    width: 73.28,
    height: 78.57,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.32
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 588.25,
    y: 151.995
  }, "\n        Pitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 624.9,
    y: 112.71,
    width: 75.1,
    height: 78.57,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 662.4499999999999,
    y: 151.995
  }, "\n        Ashe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 159.79,
    y: 191.28,
    width: 73.76,
    height: 80.96,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.22
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 196.67,
    y: 231.76
  }, "\n        Caldwell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 159.79,
    y: 272.24,
    width: 73.76,
    height: 81.37,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.537142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 196.67,
    y: 312.925
  }, "\n        Harnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 159.79,
    y: 353.61,
    width: 73.76,
    height: 85.83,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.195555555555556
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 196.67,
    y: 396.52500000000003
  }, "\n        Henderson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 159.79,
    y: 439.44,
    width: 73.76,
    height: 86.14,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.537142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 196.67,
    y: 482.51
  }, "\n        Sampson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 159.79,
    y: 525.58,
    width: 73.76,
    height: 87.15,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.537142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 196.67,
    y: 569.1550000000001
  }, "\n        Robeson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 159.79,
    y: 612.73,
    width: 73.76,
    height: 87.27,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.293333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 196.67,
    y: 656.365
  }, "\n        Stanly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 233.55,
    y: 191.28,
    width: 81.99,
    height: 81.92,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.702857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 274.545,
    y: 232.24
  }, "\n        Haywood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 315.53,
    y: 191.28,
    width: 92.35,
    height: 81.92,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.384
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 361.705,
    y: 232.24
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 407.88,
    y: 191.28,
    width: 96.26,
    height: 81.92,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.102222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 456.01,
    y: 232.24
  }, "\n        Cleveland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 504.14,
    y: 191.28,
    width: 96.9,
    height: 81.92,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.384
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 552.59,
    y: 232.24
  }, "\n        Surry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 601.04,
    y: 191.28,
    width: 98.96,
    height: 81.92,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.192
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 650.52,
    y: 232.24
  }, "\n        Rockingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 233.55,
    y: 273.2,
    width: 101.87,
    height: 84.46,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.446
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 284.485,
    y: 315.43
  }, "\n        Rutherford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 233.55,
    y: 357.66,
    width: 101.87,
    height: 85.17,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.195
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 284.485,
    y: 400.245
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 233.55,
    y: 442.83,
    width: 101.87,
    height: 85.21,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.65125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 284.485,
    y: 485.435
  }, "\n        Alamance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 233.55,
    y: 528.05,
    width: 101.87,
    height: 85.91,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.318333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 284.485,
    y: 571.005
  }, "\n        Durham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 233.55,
    y: 613.95,
    width: 101.87,
    height: 86.05,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.75625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 284.485,
    y: 656.975
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 335.42,
    y: 273.2,
    width: 87.58,
    height: 100.79,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.9475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 379.21000000000004,
    y: 323.59499999999997
  }, "\n        Cabarrus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 423,
    y: 273.2,
    width: 87.59,
    height: 100.79,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.512857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 466.795,
    y: 323.59499999999997
  }, "\n        Iredell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 510.59,
    y: 273.2,
    width: 90.3,
    height: 100.79,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.2875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 555.74,
    y: 323.59499999999997
  }, "\n        Johnston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 600.89,
    y: 273.2,
    width: 99.11,
    height: 100.79,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 19.822
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 650.4449999999999,
    y: 323.59499999999997
  }, "\n        Rowan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 335.42,
    y: 373.99,
    width: 104.23,
    height: 97.47,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.924285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 387.535,
    y: 422.725
  }, "\n        Catawba\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 335.42,
    y: 471.46,
    width: 104.23,
    height: 103.61,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.95125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 387.535,
    y: 523.265
  }, "\n        Davidson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 335.42,
    y: 575.07,
    width: 104.23,
    height: 124.93,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 26.0575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 387.535,
    y: 637.5350000000001
  }, "\n        Wake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 439.65,
    y: 373.99,
    width: 125.5,
    height: 103.85,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.308333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 502.4,
    y: 425.915
  }, "\n        Gaston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 565.15,
    y: 373.99,
    width: 134.85,
    height: 103.85,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.835714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 632.5749999999999,
    y: 425.915
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 439.65,
    y: 477.84,
    width: 168.14,
    height: 107.2,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.745454545454546
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 523.72,
    y: 531.4399999999999
  }, "\n        Mecklenburg\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 439.65,
    y: 585.03,
    width: 168.14,
    height: 114.97,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.37125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 523.72,
    y: 642.515
  }, "\n        Buncombe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 607.79,
    y: 477.84,
    width: 92.21,
    height: 222.16,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.52625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 653.895,
    y: 588.92
  }, "\n        Guilford\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1936);
export default __webpack_public_path__ + "static/media/1936.db6609651fbe5cfe2d7cb22caba8d446.svg";
export { ForwardRef as ReactComponent };